import { InjectionToken } from '@angular/core';

import { PopoverData } from './popover-data.interface';

export const POPOVER_DATA = new InjectionToken<PopoverData>('POPOVER_DATA');
